import { FleetActionTypes, FleetTrucksChangedMessage } from '@numeo/types-main-web-app'
import type { AppDispatch } from 'store'
import { FLEET_TRUCKS_COUNTS_ID, FLEET_TRUCKS_LIST_ID, fleetTrucksApi } from 'store/api/fleetTrucksApi'

/**
 * `fleet.trucksChanged`: someone created, changed or deleted trucks of this company. Every cached page, count and match is
 * read again (re-read where on screen, dropped elsewhere), and so is each truck named; `all` reads every truck again.
 */
export const handleFleetMessages = (message: FleetTrucksChangedMessage, dispatch: AppDispatch): void => {
    if (message.data?.action !== FleetActionTypes.TrucksChanged) return
    if (message.data.all) {
        dispatch(fleetTrucksApi.util.invalidateTags(['Trucks']))
        return
    }
    dispatch(
        fleetTrucksApi.util.invalidateTags([
            { type: 'Trucks', id: FLEET_TRUCKS_LIST_ID },
            { type: 'Trucks', id: FLEET_TRUCKS_COUNTS_ID },
            ...message.data.truckIds.map((id) => ({ type: 'Trucks' as const, id })),
        ])
    )
}
